import React from 'react';
import { useTranslation } from 'react-i18next';
import CoachChatPanel from './CoachChatPanel';

/**
 * Temporary wrapper: reuses the existing chat body but renders it as a right-side drawer
 * (instead of a centered modal) on desktop.
 *
 * We'll later factor the shared logic into a true panel component (also used on mobile tab).
 */
export default function CoachChatDrawer({ isOpen, onClose, planId, canEdit, lang, onPlanChanged, plan = null }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  // We render the same content as CoachChatModal, but override the outer layout.
  // CoachChatModal already renders a full UI; we use it for now and rely on CSS wrappers.
  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {/* Click-catcher overlay only on small screens */}
      <div className="absolute inset-0 bg-black/30 md:bg-transparent pointer-events-auto" onClick={onClose} />

      <div className="absolute top-0 right-0 h-full w-full md:w-[520px] lg:w-[600px] bg-white shadow-2xl border-l border-gray-200 pointer-events-auto">
        <div className="h-full flex flex-col">
          <div className="p-4 border-b border-gray-100 flex items-center justify-between">
            <div className="text-sm font-extrabold text-gray-900">
              {t('chat.title')}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-gray-700 px-3 py-1"
              aria-label={t('workout.close')}
            >
              ✕
            </button>
          </div>

          <div className="flex-1 min-h-0">
            <CoachChatPanel
              isActive
              planId={planId}
              canEdit={canEdit}
              lang={lang}
              onPlanChanged={onPlanChanged}
              plan={plan}
            />
          </div>
        </div>
      </div>
    </div>
  );
}


